// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import ILogo from "@/models/ILogo";

export class State extends CrudState {
  dataList: Array<ILogo> = [];
  dataItem: ILogo | null = null;
  selectedForApproval: ILogo | null = null;
}
